import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import { withRouter, RouteComponentProps } from 'react-router';
import { authSelectors } from '@ui/store/auth';
import { routes } from './config';
import { StoreState } from '@ui/store/rootReducer';
import { UserRoles } from '@ui/services/userRole';

import Login from '../pages/Login';
import Home from '../pages/Home';

import ManagerRoutes from './ManagerRoutes';
import ContentManagerRoutes from './ContentManagerRoutes';
import { AdminRoutes } from './AdminRoutes';

interface StateToProps {
  loggedIn: boolean;
  role: string;
}

interface PrivateRoutesProps {
  role: string;
}

type Props = StateToProps & RouteComponentProps;

const PrivateRoutes: React.FunctionComponent<PrivateRoutesProps> = ({
  role,
}) => {
  switch (role) {
    case UserRoles.admin.key:
      return <AdminRoutes />;
    case UserRoles.manager.key:
      return <ManagerRoutes />;
    case UserRoles.contentManager.key:
      return <ContentManagerRoutes />;
    default:
      return (
        <Switch>
          <Route exact path={routes.home} component={Home} />
          <Redirect to={routes.home} />
        </Switch>
      );
  }
};

const PublicRoutes = () => (
  <Switch>
    <Route exact path={routes.login} component={Login} />
    <Redirect to={routes.login} />
  </Switch>
);

const Routes: React.FunctionComponent<Props> = ({ loggedIn, role }) =>
  loggedIn ? <PrivateRoutes role={role} /> : <PublicRoutes />;

const mapStateToProps = (state: StoreState): StateToProps => ({
  loggedIn: authSelectors.getLoggedIn(state),
  role: authSelectors.getUserRole(state),
});

export default withRouter(connect(mapStateToProps)(Routes));



// WEBPACK FOOTER //
// ./src/Routes/Routes.tsx